import type { ReactNode } from "react";
import { Badge, Text } from "@marekl/adminer/components";
import { BadgeRow } from "../BadgeRow";
import { formatDuration, formatFileSize } from "../../lib/musicState";
import styles from "./MusicFileSummary.module.css";

export interface MusicFileSummaryProps {
  name: string;
  durationMs: number;
  bitrateKbps: number;
  sizeBytes: number;
  /** Rendered under the facts — e.g. who the recording belongs to. */
  note?: ReactNode;
}

/**
 * What a stored MP3 is: its name and the three numbers a leader can act on.
 *
 * Each fact says what it is. „320 kbps" is only obvious to somebody who
 * already knows what a bitrate is, and the leader uploading the file is not
 * that person.
 */
export function MusicFileSummary({
  name,
  durationMs,
  bitrateKbps,
  sizeBytes,
  note,
}: MusicFileSummaryProps) {
  return (
    <>
      <div className={styles.file}>
        <Text className={styles.name}>{name}</Text>
        <BadgeRow>
          <Badge variant="muted">Délka {formatDuration(durationMs)}</Badge>
          <Badge variant="muted">Kvalita {bitrateKbps} kbps</Badge>
          <Badge variant="muted">Velikost {formatFileSize(sizeBytes)}</Badge>
        </BadgeRow>
      </div>
      {note && (
        <Text as="div" variant="muted">
          {note}
        </Text>
      )}
    </>
  );
}
